import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box, IconButton, Link, Typography } from "@mui/material";
import React, { useState } from "react";

const MIGRATION_URL = "https://prod.streampreview.live-infrastructure.prime-video.amazon.dev/";

/**
 * Dismissible warning banner announcing that StreamPreview has migrated to a
 * new portal and that this portal will be unavailable from October 1st onwards.
 *
 * Shared between the login page (rendered below the header) and the post-login
 * dashboard (rendered on top).
 *
 * @param {object} [props]
 * @param {object} [props.sx] Optional MUI `sx` overrides merged into the banner
 *   container. Used by the dashboard to offset the banner to the right of the
 *   fixed left menu icons so it aligns with the content window.
 * @returns {JSX.Element|null} The banner, or null once dismissed.
 */
export const MigrationBanner = ({ sx = {} }) => {
    const [open, setOpen] = useState(true);

    if (!open) {
        return null;
    }

    return (
        <Box
            role="alert"
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: "100%",
                boxSizing: "border-box",
                px: 2,
                py: 1,
                backgroundColor: "#2c1b03",
                color: "#ff9100",
                borderBottom: "1px solid #ff9100",
                ...sx,
            }}
        >
            <WarningAmberIcon fontSize="small" sx={{ flexShrink: 0 }} />
            <Typography variant="body2" sx={{ flexGrow: 1 }}>
                {"StreamPreview has migrated to "}
                <Link
                    href={MIGRATION_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ color: "#ff9100", fontWeight: "bold", textDecorationColor: "#ff9100" }}
                >
                    {MIGRATION_URL}
                </Link>
                {". This portal will be unavailable from October 1st onwards."}
            </Typography>
            <IconButton
                aria-label="dismiss migration notice"
                size="small"
                onClick={() => setOpen(false)}
                sx={{ color: "#ff9100", flexShrink: 0 }}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </Box>
    );
};

export default MigrationBanner;
